module.exports = __webpack_public_path__ + "img/slider_14.025da8cd.jpg";